import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PieChart, Pie, Tooltip, Cell, Legend } from 'recharts';
import { cleanFilter, updateFilter } from '../../redux/actions/filtroAction';
import ambiente from '../../config/ambienteConfig';

class Proventos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            quadro: [],
        };
    }

    componentDidMount = () => {
        this.updateGrafico();
    }

    updateGrafico = async () => {
        const res = await axios.get(`${ambiente.dev.server}/relatorios/carteira`);
        this.setState({ quadro: res.data });
    }

    render() {
        const cores = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
        return (
            <div>
                <div>
                    <PieChart width={500} height={300}>
                        <Pie data={this.state.quadro.geral} nameKey="nome" dataKey="saldo"
                             fill="#82ca9d">
                             { this.state.quadro.geral &&
                                this.state.quadro.geral.map((entry, index) => 
                                    <Cell key={entry.nome} fill={cores[index % cores.length]}/>) }
                        </Pie>
                        <Tooltip cursor={false}/>
                        <Legend />
                    </PieChart>
                </div>
                <div>
                    <PieChart width={500} height={300}>
                        <Pie data={this.state.quadro.acoes} nameKey="ativo" dataKey="saldo"
                             fill="#82ca9d">
                             { this.state.quadro.acoes &&
                                this.state.quadro.acoes.map((entry, index) => 
                                    <Cell key={entry.ativo} fill={cores[index % cores.length]}/>) }
                        </Pie>
                        <Tooltip cursor={false}/>
                    </PieChart>
                </div>
                <div>
                    <PieChart width={500} height={300}>
                        <Pie data={this.state.quadro.fiis} nameKey="ativo" dataKey="saldo"
                             fill="#82ca9d">
                             { this.state.quadro.fiis &&
                                this.state.quadro.fiis.map((entry, index) => <Cell key={entry.ativo} fill={cores[index % cores.length]}/>) }
                        </Pie>
                        <Tooltip cursor={false}/>
                    </PieChart>
                </div>
                <div>
                    <PieChart width={500} height={300}>
                        <Pie data={this.state.quadro.td} nameKey="ativo" dataKey="saldo"
                             fill="#82ca9d">
                             { this.state.quadro.td &&
                                this.state.quadro.td.map((entry, index) => <Cell key={entry.ativo} fill={cores[index % cores.length]}/>) }
                        </Pie>
                        <Tooltip cursor={false}/>
                    </PieChart>
                </div>
                <div>
                    <PieChart width={500} height={300}>
                        <Pie data={this.state.quadro.rfixa} nameKey="ativo" dataKey="saldoTotal"
                             fill="#82ca9d">
                             { this.state.quadro.rfixa &&
                                this.state.quadro.rfixa.map((entry, index) => <Cell key={entry.ativo} fill={cores[index % cores.length]}/>) }
                        </Pie>
                        <Tooltip cursor={false}/>
                    </PieChart>
                </div>
            </div>
        );
    }
}

Proventos.propTypes = {
    updateFilter: PropTypes.func.isRequired,
    cleanFilter: PropTypes.func.isRequired,
    filtro: PropTypes.object.isRequired
  };
  
  function mapStateToProps({filtro}) {
    return {
        filtro: filtro
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      updateFilter: filtro => dispatch(updateFilter(filtro)),
      cleanFilter: () => dispatch(cleanFilter())
    };
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(Proventos);



// WEBPACK FOOTER //
// ./src/components/graficos/Carteira.js